<mat-toolbar color="primary" class="mat-elevation-z6">
  <button mat-icon-button (click)="menuClick.emit()"><mat-icon>menu</mat-icon></button>
  <button matRipple routerLink="/dashboard" class="logo-button"><img src="./assets/cp-logo.png" /></button>

  <div class="spacer"></div>

  <button mat-icon-button [matMenuTriggerFor]="accountMenu" matTooltip="Account" i18n-matTooltip matTooltipShowDelay="1000">
    <mat-icon>person</mat-icon>
    <mat-menu #accountMenu>
      <div class="account-email">{{ (authService.user$ | async).email }}</div>
      <button mat-menu-item (click)="openProfile()" i18n>Profil</button>
      <button mat-menu-item (click)="logout()" i18n>Abmelden</button>
    </mat-menu>
  </button>
  <button mat-button [matMenuTriggerFor]="languageMenu" i18n-matTooltip matTooltip="Sprache" matTooltipShowDelay="1000">
    <mat-menu #languageMenu>
      <button mat-menu-item (click)="changeLanguage('de')"
        ><mat-icon>{{ language === 'de' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon
        ><span>Deutsch</span></button
      >
      <button mat-menu-item (click)="changeLanguage('en')"
        ><mat-icon>{{ language === 'en' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon
        ><span>English</span></button
      >
    </mat-menu>
    @switch (language) {
      @case ('en') {
        EN
      }
      @case ('de') {
        DE
      }
    }
  </button>
</mat-toolbar>
